import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import RotateLeft from 'react-icons/lib/fa/rotate-left';

import Styles from './MapDetailsForm.styles';

class MapDetailsFormSection extends Component {
  constructor(props) {
    super(props);
    this.resetFields = this.resetFields.bind(this);
  }

  resetFields() {
    const tmp = {};
    const children = this.props.children;
    React.Children.forEach(children, (item) => {
      tmp[item.props.name] = item.props.value ? item.props.value : '';
    });
    this.props.onReset(tmp);
  }

  render() {
    const { contentStyle = {} } = this.props;
    return (
      <div style={Styles.wrapper}>
        {!this.props.hideHeader && (
          <div style={Styles.header}>
            <span style={Styles.headerText}>{this.props.title}</span>
            {this.props.showIcon && (
              <RotateLeft
                style={{ color: '#476166', cursor: 'pointer' }}
                onClick={this.resetFields}
              />
            )}
          </div>
        )}
        <div style={[Styles.content, contentStyle]}>{this.props.children}</div>
      </div>
    );
  }
}

MapDetailsFormSection.propTypes = {
  children: PropTypes.node,
  hideHeader: PropTypes.bool,
  title: PropTypes.string,
  onResetClick: PropTypes.func,
  showIcon: PropTypes.bool,
};

MapDetailsFormSection.defaultProps = {
  children: null,
  hideHeader: false,
  title: '',
  onResetClick: () => {},
  showIcon: true,
};

export default Radium(MapDetailsFormSection);



// WEBPACK FOOTER //
// ./src/components/Map/MapDetailsForm/MapDetailsFormSection.js